export const login = {
  loginSuccessfully: 'ログインしました。',
  loginError: 'ユーザーIDまたはパスワードが正しくありません。',
}
